import { render, staticRenderFns } from "./SmartCardsView.vue?vue&type=template&id=b4726650&scoped=true&lang=pug&"
import script from "./SmartCardsView.vue?vue&type=script&lang=js&"
export * from "./SmartCardsView.vue?vue&type=script&lang=js&"
import style0 from "./SmartCardsView.vue?vue&type=style&index=0&id=b4726650&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4726650",
  null
  
)

export default component.exports